import React from 'react'
import styles from './simpleMagnifierIcon.module.scss'

const SimpleMagnifierIcon: React.FC<{}> = props => {
  return <div className={styles.magnifier} />
}

export default SimpleMagnifierIcon
